import { MergeTagVariable } from 'types';

export interface VariableInText {
  index: number;
  key: string;
  match: string;
  fallback: string;
}
export function extractTextVariableCandidates(text: string): VariableInText[] {
  const matches = [...text.matchAll(/{{([A-Za-z._\- ]+)(\|"([^}}]*)")?}}/g)];
  return matches.map(m => {
    const index = m.index || -1;
    const key = m.length > 1 ? m[1] : '';
    const match = m.length > 0 ? m[0] : '';
    const fallback = m.length > 3 ? m[3] : '';
    return { index, key, match, fallback } as VariableInText;
  });
}

export const sanitizeString = (s: string) => {
  // XSS mitigation - just strip out anything naughty, this would be an inter-org attack since
  // this is something that displays in the journey builder
  return s.replace(/(\b)(on\S+)(\s*)=|javascript|<(|\/|[^/>][^>]+|\/[^>][^>]+)>/gi, '');
};

export const replaceVariablesWithExamples = (
  s: string,
  variables: MergeTagVariable[],
  noMarkup?: boolean,
) => {
  let modified = sanitizeString(s);
  variables.forEach(cmv => {
    const re = makeRegexForVar(cmv.key);
    modified = modified.replaceAll(
      re,
      noMarkup ? cmv.exampleValue : `<b>${cmv.exampleValue}</b>`,
    );
  });
  return modified;
};

export const mdHyperlinksToAnchorTags = (text: string) => {
  const htmlText = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_match, text, url) => {
    const fullUrl = url.startsWith('https://') ? url : `https://${url}`;
    return `<a href="${fullUrl}" target="_blank">${text}</a>`;
  });

  return htmlText;
};

export function makeRegexForVar(key: string, noFallback = false) {
  if (noFallback) {
    return new RegExp(`{{${key}}}`, 'gm');
  }
  return new RegExp(`{{${key}(\\|"[^}}]*")?}}`, 'gm');
}

export function chatMessageVariableForKey(
  key: string,
  chatMessageVariables?: MergeTagVariable[],
) {
  if (!chatMessageVariables) return;
  return chatMessageVariables.find(cmv => cmv.key === key);
}

export function clenseFallbackText(text: string) {
  return text.replace(/{|}|"|"/g, '');
}
